export const ABOUT_SITE_EDIT_BUTTON_LABEL = 'about-site.edit-button-label';
export const ABOUT_SITE_PHOTO_ALT = 'about-site.photo-alt';
